/******************************************************
 *                  Global exploitation Courses Ctrl
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("ExploitStopPointsCtrl", [
		"ExploitationService", "$compile", "OkinaLeafletService", "MapService", "networks", "EitiPointsBusinessService", "Utils", "$uibModal", "$routeParams","toastr", "$scope", "$timeout", "SecurityService", "$sanitize",
		function (ExploitationService, $compile, OkinaLeafletService, MapService, networks, EitiPointsBusinessService, Utils, $uibModal, $routeParams,toastr, $scope, $timeout, SecurityService, $sanitize) {

		ExploitationService.updateNetworkCache(networks);
		/******************************************************
			 *                  SETUP
			 ********************************************************/
		$scope.data = {
			map: {},
			mapFeatures: {},
			stopPoints: [],
			commercialPoints: [],
			trace: [],
			networks: networks.data,
			stopPointsTranformation: [],
			importLoading: false
		};

		const newMarkerKey = "NEW_MARKER_ID";

		$scope.exploitationService = ExploitationService;
		$scope.utilsService = Utils;
		$scope.isAllSelected = false;
		$scope.sortColumn = "name";
		$scope.reverseSort = false;
		$scope.currentLatitude = 0.0;
		$scope.currentLongitude = 0.0;

		let stopPointBackup,
			movePointModal,
			stopPointForm,
			dragging = false,
			alreadyInBearingMode = false,
			linkToSearchStopPoints,
			linkToImportStopPoints;

		$scope.featuresPopupTemplate = MapService.featureTemplates.routeStopPoint;

		$scope.LeafletService = OkinaLeafletService;
		initMap();

		/**
		 * Restful navigation.
		 */
		function initPoint()
		{
			if ($routeParams.stopPointId) {

				let selectedPoint = $scope.data.displayedStopPoints.find(point=> point.id === parseInt($routeParams.stopPointId));
				ExploitationService.setCurrentStopPoint(selectedPoint);
				setSelectedStopPointFromId( parseInt($routeParams.stopPointId));

				OkinaLeafletService.setCenter({
					lng: selectedPoint.longitude,
					lat: selectedPoint.latitude,
					zoom: 15
				});
			}
		}



		/******************
			 * SCOPE FUNCTIONS
			 ******************/

		/**
			 * Callback on point click.
			 * Loads stop point infos into scope so it get displayed on the page.
			 * Re-draw the map => as there is a $scope.data.currentStopPoint now, map will zoom and center onto it
			 *
			 * First, check that this very point isn't already selected => in this case do nothing, and ol-map directive will show standard line connections popup.
			 */
		$scope.stopPointSelected = function (mapStopPoint) {
			if (!$scope.data.currentStopPoint || mapStopPoint.feature.data.point.id !== $scope.data.currentStopPoint.id || mapStopPoint.feature.data.point.liaisons !== null && mapStopPoint.feature.data.point.liaisons.length === 0) {
				ExploitationService.getNetworkLinesInfoForStopPoint(mapStopPoint.feature.data.point.id)
					.then((response) =>  {
						const data = response.data;
						if (data[0].liaisons.length > 0) {
							mapStopPoint.feature.attributes.point.liaisons = data[0].liaisons;
						} else {
							mapStopPoint.feature.attributes.point.liaisons = null;
						}
					});
				$scope.data.editMode = false;
				$scope.$apply(function () {
					populateCurrentStopPoint(mapStopPoint.feature.attributes.point);
				});
			}
		};

		$scope.toggleLineStopPoints = function (line) {
			clearMapStateAndMarkers();
		};

		$scope.isSimulation = function () {
			const ref =  window.sessionStorage.getItem("referential");
			if (ref != null) {
				return ref.startsWith("simulation_");
			} else {
				return false;
			}
		}

		if (SecurityService.hasRight('admin') ) {
				$scope.areModificationsAllowed = true;
		}

		/**
			 * Edit button (green pencil).
			 * Makes a copy of current stop point data so it can be reloaded if user wants to cancel edition.
			 * Loads commercial points visible on the map.
			 * Center the map on the selected point and zoom on it
			 *
			 * @param form
			 */
		$scope.enterEditMode = function (form) {
			stopPointForm = form;
			$scope.data.editMode = true;
			stopPointBackup = Utils.clone($scope.data.currentStopPoint);

			//reset du nom commercial du point courant
			$scope.data.currentCommercialStopArea = {};

			// on zoom sur le point d'arrêt sélectionné
			OkinaLeafletService.setCenter({
				lat: $scope.data.currentStopPoint.latitude,
				lng: $scope.data.currentStopPoint.longitude,
				zoom: 10
			});

			// workaround pour afficher le point sur la map quand on rentre en édition depuis une page RESTFull
			OkinaLeafletService.setZoom(20);


			OkinaLeafletService.getMap().then(m => {
				// On rend le marker draggable
				let marker = OkinaLeafletService.getMarkerWithName($scope.data.currentStopPoint.id);

				// TODO : Figure out how to spiderfy Parent after zoom
				if (marker.__parent != null) {
					marker.__parent.spiderfy();
				}

				let draggingState = marker.dragging;
				if (draggingState != null) {
					draggingState.enable();
				}
				marker.on("dragend", function () {
					draggableFeatureCallbackFunction(marker.getLatLng());
				});

				// get commercial names for current map bounds
				loadCommercialNamesForCurrentMapBounds();
			});
		};

		/**
		 * Load list of stop points in the bounds of the view into the $scope of the controler
		 */
		function loadCommercialNamesForCurrentMapBounds() {
			OkinaLeafletService.getMap().then(function (map) {
				ExploitationService.getStopPointsByCoordinates(
					map.getBounds()._southWest.lat, map.getBounds()._northEast.lat,
					map.getBounds()._southWest.lng, map.getBounds()._northEast.lng
				).then((response) => {
					const data = response.data;
					$scope.data.currentMapAreaCommercialNames = data.commercial_stop_area;
					$scope.data.currentCommercialStopArea = $scope.data.currentMapAreaCommercialNames
						.find(sa => sa.id === $scope.data.currentStopPoint.commercial_stop_area);
				});
			});
		}

		/**
		 * Cancel editing (yellow cross)
		 * Will load backed up data into point and reset some stuff.
		 */
		$scope.cancelEdit = function () {
			$scope.data.editMode = false;

			if (stopPointForm) {
				stopPointForm.$setPristine();
			}

			stopPointBackup = {};

			OkinaLeafletService.deleteAllMarkers();
			loadMarkers();
		};

		/**
			 * Click on the map :
			 * - get GPS coordinates into the model.
			 * - draw the point on the map.
			 * @param e event click.
			 */
		function handleMapClick(e) {

			OkinaLeafletService.getMap().then((map) => {

				// On ajoute un nouveau marker
				let marker = {
					lat: e.latlng.lat,
					lng: e.latlng.lng,
					icon: {
						type: "awesomeMarker",
						icon: "circle",
						prefix: "fa",
						markerColor: "blue",
					}
				};

				OkinaLeafletService.createMarkerWithName(newMarkerKey, marker);

				// on supprime l'evenementiel sur la map
				map.off("click", handleMapClick);
				// On réinitialise le curseur
				OkinaLeafletService.getMap().then((map) => {
					$(map._container).css("cursor", "grab");
				});

				// On le lie au $scope
				$scope.data.currentStopPoint.longitude = Number(Math.round(marker.lng + "e8") + "e-8");
				$scope.data.currentStopPoint.latitude = Number(Math.round(marker.lat + "e8") + "e-8");

				// on zoom sur le point d'arrêt sélectionné
				OkinaLeafletService.setCenter({
					lat: $scope.data.currentStopPoint.latitude,
					lng: $scope.data.currentStopPoint.longitude,
					zoom: 20,
				});

				let currentMarker = OkinaLeafletService.getMarkerWithName(newMarkerKey);

				// On rend le marker draggable
				let drag = currentMarker.dragging;
				if (drag != null) {
					drag.enable();
				}
				currentMarker.on("dragend", function () {
					draggableFeatureCallbackFunction(currentMarker.getLatLng());
				});

				// get commercial names for current map bounds
				loadCommercialNamesForCurrentMapBounds();

			});

		}

		$scope.checkGeolocModificationAndPost = function (form) {
			if ($scope.data.currentLatitude !== $scope.data.currentStopPoint.latitude || $scope.data.currentLongitude !== $scope.data.currentStopPoint.longitude){
				$scope.openMovePointModal();
			}else{
				$scope.postEditedPoint(form);
			}
		}



		/**
			 * Send added or updated point to server.
			 * - Send data
			 * - Notification
			 * - reset form state
			 * - reset app state (edit / creation mode)
			 * - re-fetch stop points
			 */
		$scope.postEditedPoint = function () {

			$scope.data.currentStopPoint.commercial_name = $scope.data.currentCommercialStopArea.name;
			$scope.data.currentStopPoint.commercial_stop_area = $scope.data.currentCommercialStopArea.id;


			// choose service to use
			let service = ExploitationService.updateStopAreaBoarding;

			// send data
			service($scope.data.currentStopPoint)
				.then(() => {

					// notification
					toastr.success("Point modifié avec succès - merci de bien vouloir patienter pendant le rechargement de la carte", "");

					stopPointBackup = {};

					$scope.cancelEdit();
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de l'enregistrement du point. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		/**
		 * Open point move modal confirmation.
		 */
		$scope.openMovePointModal = function () {
			movePointModal = Utils.openModal($uibModal, "movePointModal.html", $scope);
		};

		$scope.movePoint = function (form) {
			movePointModal.close();
			$scope.postEditedPoint(form);
		}

		/**
			 * Search commercial points in the area if in edit mode
			 * @param bounds
			 */
		$scope.mapRefreshedCallback = function (bounds) {
			if ($scope.data.editMode) {
				ExploitationService.getStopPointsByCoordinates(
					bounds.bottom,
					bounds.top,
					bounds.left,
					bounds.right
				).then((response) => {
					$scope.data.currentMapAreaCommercialNames = response.data.commercial_stop_area;
				});
			}
		};

		/**
			 * Simply draw a point on the map.
			 */
		$scope.drawPoint = function () {
			if ($scope.data.currentStopPoint.latitude && $scope.data.currentStopPoint.longitude) {
				MapService.drawSimplePoint($scope.data.map, $scope.data.currentStopPoint.latitude, $scope.data.currentStopPoint.longitude, MapService.markerStyles.highlight, true);
			}
		};


		/**
			 * Reusing networks display component.
			 * Specialized callback function here to not display points, but only route trace.
			 * @param network
			 */
		$scope.networkSelectedSpecialized = function (network) {
			// Cette modification va recharger le tracé des lignes
			$scope.data.selectedNetwork = network;
			// don't clear markers on map refresh
			//ExploitationService.disableZoomAndMarkersClearing();
			ExploitationService.setCurrentNetwork(network);

			ExploitationService.getStopAreasByNetwork(network.id).then((response) => {
				$scope.data.stopPoints = response.data;

				OkinaLeafletService.setCenter({
					lng: $scope.data.stopPoints[0].longitude,
					lat: $scope.data.stopPoints[0].latitude,
					zoom: 9
				})

			});
		};


		/**
			 * Helps user to estimate a bearing by drawing a segment on the map.
			 * First point is automatically set as current edited stop point.
			 */
		$scope.drawBearing = function () {

			if (!alreadyInBearingMode) {
				alreadyInBearingMode = true;

				// remove 'add a new point" handler
				MapService.removeListenerFromMap($scope.data.map, "click", handleMapClick);

				MapService.showBearingHelp(
					$scope.data.map,
					$scope.data.currentStopPoint.longitude,
					$scope.data.currentStopPoint.latitude,
					bearingCallback);
			}

		};

		$scope.importStopPointFile = function () {
			$scope.data.importLoading = true;
			ExploitationService.postStopPointsImport($scope.data.importFile).then((response) => {
				const data = response.data;
				toastr.success("", "Import terminé");
				$scope.data.importLoading = false;

				if(data.stopAreas.length === 0) {
					$scope.closeStopPointImportModal();
				}
				else {
					$scope.data.stopAreasNotFound = data.stopAreas;
				}

			}).catch((error) => {
				toastr.error(error.data.message, "Problème lors de l'import");
				$scope.data.importLoading = false;
			});
		};

		/*
		 * Ouvre un modal pour importer une table de correspondance
		 */

		$scope.openImportStopPointsModal = function () {
			$scope.data.stopAreasNotFound = undefined;
			linkToImportStopPoints = Utils.openModal($uibModal, "import-stop-points.html", $scope, "lg");
		};

			/*
     	* Fermeture du modal.
     	*/

			$scope.closeStopPointImportModal = function () {
				linkToImportStopPoints.close();
			};


		/*
		 * Ouvre un modal pour rechercher les points d'arrêt par nom.
		 */

		$scope.openSearchStopPointsModal = function () {
			linkToSearchStopPoints = Utils.openModal($uibModal, "search-stop-points.html", $scope, "lg");
		};

		/*
			 * Fermeture du modal.
			 */

		$scope.closeStopPointSearchModal = function () {
			linkToSearchStopPoints.close();
			$scope.data.stopPointsSearch = {};
		};


		/*
			 * Recherche de(s) point(s) d'arrêt(s) par un nom.
			 */

		$scope.searchStopPoints = function (name) {
			ExploitationService.searchStopPointsByName(name).then((response) => {
				$scope.data.stopPointsSearch = response.data;
			});
		};


		/*
			 * Retourne les infos et affiche la map pour le stop point selectionné.
			 */
		$scope.returnStopPointSearch = function (stopPoint) {
			setSelectedStopPointFromId(stopPoint.id);
			linkToSearchStopPoints.close();
			$scope.data.stopPointsSearch = {};

			// on zoom sur le point d'arrêt sélectionné
			OkinaLeafletService.setCenter({
				lat: stopPoint.latitude,
				lng: stopPoint.longitude,
				zoom: 20
			});
		};

		$scope.updateMapWithCurrentStopPoint = function () {
			if (getDecimalNumber($scope.data.currentStopPoint.latitude) >= 1 && getDecimalNumber($scope.data.currentStopPoint.longitude) >= 1) {
				$scope.data.currentStopPoint.center = true;
				drawMap();
			}
		};

		$scope.importManualStopsFile = function () {
			if($scope.data.manualImportFile === undefined){
				toastr.error("Sélectionner un fichier", "Erreur lors de l'import");
				$scope.data.importLoading = false;
				return;
			}
			$scope.data.importLoading = true;


			ExploitationService.postManualStopsFile($scope.data.manualImportFile).then(() => {
				toastr.success("", "Import terminé");
				$scope.data.importLoading = false;

				$scope.closeImportManualStopsModal();
				$scope.data.importFile = undefined;
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur lors de l'import");
				$scope.data.importLoading = false;
				$scope.data.manualImportFile = undefined;
				$scope.closeImportManualStopsModal();
			});
		};


		$scope.closeImportManualStopsModal = function () {
			linkImportStopsCSV.close();
		};


		/******************
			 * UTILS
			 ******************/

		function initMap(zoomTo) {
			OkinaLeafletService.init("map",  {markerLayerCluster: true});

			OkinaLeafletService.setCenter({
				lat:  zoomTo ? zoomTo.lat : 47.070659,
				lng:  zoomTo ? zoomTo.lng : 1.6146023,
				zoom: zoomTo ? zoomTo.zoom : 6
			});
			// moveend is also triggered after zooming
			OkinaLeafletService.addEventOnMap("moveend", 1000, function () {
				if ($scope.data.editMode) {
					loadCommercialNamesForCurrentMapBounds();
				}
			});

			loadMarkers();
		}

		/**
			 * Clear map from active state (select/edit/create):
			 * - unselect all markers and close popup
			 * - remove data.currentStopPoint
			 */
		function clearMapStateAndMarkers() {

			OkinaLeafletService.unselectAllMarkers();
			OkinaLeafletService.getMap().then(function (map) {
				map.closePopup();
			});
			populateCurrentStopPoint(null);

			let linesToDisplay = [];

			if ($scope.data.linesPaths) {
				$scope.data.linesPaths.forEach(function (line) {
					if ($scope.data.linesToDisplay[line.id]) {
						linesToDisplay.push(line);
					}
				});
			}

		}

		/**
			 * Called when point dragging is done (when adding / editing a point).
			 * - set coordinates in the form to new dragged point coordinates
			 * - set form state as $dirty
			 * - load comercial names for the form
			 *
			 * @param markerLatLng
			 */
		function draggableFeatureCallbackFunction(markerLatLng) {
			$scope.data.currentStopPoint.longitude = Number(Math.round(markerLatLng.lng + "e8") + "e-8");
			$scope.data.currentStopPoint.latitude = Number(Math.round(markerLatLng.lat + "e8") + "e-8");
			stopPointForm.$setDirty();
			dragging = true;

			loadCommercialNamesForCurrentMapBounds();
		}

		/**
		 * Charge les markers pour les stoppoints
		 */
		function loadMarkers() {
			ExploitationService.getAllStopPointsForMap()
				.then((response) => {
					const stopPoints = response.data;
					$scope.data.displayedStopPoints = stopPoints;

					stopPoints
						.map(sp => {
							const color = $scope.data.currentStopPoint != null && $scope.data.currentStopPoint.id === sp.id ? "red" : "blue";
							return formatMarkerFromStopPointShow(sp, color);
						})
						.forEach(marker => {
							OkinaLeafletService.createMarkerWithName(marker.id, marker);
						});


					initPoint();

				})
				.finally(() => {
					if ($scope.data.currentStopPoint != null && $scope.data.currentStopPoint.id != null) {
						setSelectedStopPointFromId($scope.data.currentStopPoint.id);
					}
				});
			if($scope.data.selectedNetwork !== null && $scope.data.selectedNetwork !== undefined){
				ExploitationService.getStopAreasByNetwork($scope.data.selectedNetwork.id).then((stopPoints) => {
					$scope.data.stopPoints = stopPoints.data;
				});
			}
		}

		/**
		 * @param sp stop-point
		 * @param color
		 * @returns {{lng: *, icon: {number: *, markerColor: *, prefix: null, icon: string, type: string}, id: *, message: string, lat: *}}
		 */
		function formatMarkerFromStopPointShow(sp, color) {
			return {
				lat: sp.latitude,
				lng: sp.longitude,
				id: sp.id,
				icon: {
						type: "awesomeMarker",
						icon: "circle",
						prefix: "fa",
						markerColor: color,
				},
				message: "",
				onPopupOpen: (e) => {
					const clickedMarker = e.target;
					$scope.data.currentStopPoint = clickedMarker.options;
					const stopPoint = $scope.data.displayedStopPoints.find(sp => sp.id === clickedMarker.options.id);
					$scope.data.pointToDisplay = stopPoint !== undefined ? stopPoint : clickedMarker.options;
					$scope.data.populateCurrentStopPoint = populateCurrentStopPoint;
					setSelectedStopPointFromId(clickedMarker.options.id);
				}
			};
		}

		function popupHTMLTemplateForPoint(point) {
			let liaisons = "";
			let liste = point.liaisons;
			if (liste) {
				liaisons += "<br>Liaisons : <dt>";
				for (let i = 0; i < liste.length; i++) {
					let liaison = liste[i];
					liaisons = liaisons.concat("<dd>Reseau " + " : " + $sanitize(liaison.name) + "</dd>");
					for (let j = 0; j < liaison.lignes.length; j++) {
						let ligne = liaison.lignes[j];
						liaisons = liaisons.concat("<ul><li>Ligne " + $sanitize(ligne.number) + " : " + $sanitize(ligne.name) + "</li></ul>");
					}
				}
				liaisons.concat("</dt>");
			} else {
				liaisons += "<br>- Aucune liaison de ligne -";
			}

			return "<div class='olPopup'>" +
				"<br>Point d'arrêt: " + $sanitize(point.name) +
				"<br>Nom commercial : " + $sanitize(point.commercial_name) +
				// "<br>Sens : " + feature.attributes.point.way +
				liaisons +
				"</div>";
		}

		/**
		 * Sélectionne le stopPoint sur lequel l'utilisateur vient de cliquer
		 * Passe l'icone en rouge et désélectionne tous les autres markers de la view
		 * Charge le contenu de la popup du marker à afficher avec la liste des network lines
		 * On ne permet pas de sélectionner un nouveau marker si on est en mode édition ou création
		 *
		 * @param event
		 */
		function setSelectedStopPoint(event) {
			setSelectedStopPointFromId(event.target.options.id);
		}

		$scope.setSelectedStop = async function (stopPointId) {
			await setSelectedStopPointFromId(stopPointId);
		};

		/**
		 * Sélectionne le stopPoint sur lequel l'utilisateur vient de cliquer
		 * Passe l'icone en rouge et désélectionne tous les autres markers de la view
		 * Charge le contenu de la popup du marker à afficher avec la liste des network lines
		 * On ne permet pas de sélectionner un nouveau marker si on est en mode édition ou création

		 * @param stopPointId
		 */
		function setSelectedStopPointFromId(stopPointId) {
			$scope.data.editMode = false;

			// marker icon
			let marker = OkinaLeafletService.getMarkerWithName(stopPointId);

			// reset all markers icons
			OkinaLeafletService.unselectAllMarkers();

			if (marker != null) {
				marker.setIcon(OkinaLeafletService.getIcon(true));
			}

			ExploitationService.getNetworkLinesInfoForStopPoint(stopPointId).then((response) => {
				const data = response.data;
				populateCurrentStopPoint(data[0]);
				if (marker != null) { // marker dans les bounds de la carto
					marker._popup.setContent(popupHTMLTemplateForPoint(data[0]));
					marker.openPopup();
				}
			});
		}

		/**
			 * When computing the bearing, this function is called when user clicks the second segment point :
			 * - compute bearing value
			 * - set form state as $dirty
			 * - put the "click" handler back into the map.
			 * @param feature
			 */
		function bearingCallback(feature) {
			if (dragging) {
				toastr.warning("Merci de bien vouloir au préalable valider ou annuler le déplacement du point", "Action impossible");
			} else {
				let bearingValue = MapService.computeFeatureBearing(feature);
				$scope.$apply(function () {
					$scope.data.currentStopPoint.bearing = bearingValue;
					stopPointForm.$setDirty();
					clearMapStateAndMarkers();
				});

			}
			// remove map handlers for bearing help
			MapService.hideBearingHelp($scope.data.map);
			alreadyInBearingMode = false;
		}

		/**
			 * Alimente le stop point courant affiché dans la page. On calcule qq champs supplémentaires pour l'affichage.
			 * @param stopPoint
			 */
		function populateCurrentStopPoint(stopPoint) {
			$scope.data.currentStopPoint = stopPoint;
			if (stopPoint != null) {
				const longitude = Number(Math.round(stopPoint.longitude + "e8") + "e-8");
				$scope.data.currentStopPoint.longitude = longitude;
				$scope.data.currentLongitude = longitude;
				const latitude = Number(Math.round(stopPoint.latitude + "e8") + "e-8");
				$scope.data.currentStopPoint.latitude = latitude;
				$scope.data.currentStopPoint.bearing = Math.round(stopPoint.bearing);
				$scope.data.currentLatitude = latitude;
			}
		}

		/**
		 * Sélectionner ou déselectionner tous les stop points
		 */
		$scope.toggleAll = function () {
			$scope.isAllSelected = !$scope.isAllSelected;
			for (let indexStopPoint in $scope.data.stopPoints) {
				let stopPoint = $scope.data.stopPoints[indexStopPoint];
				$scope.data.stopPointsToDisplay[stopPoint.id] = $scope.isAllSelected;
			}
		};

		/**
		 * Used to check if action buttons must be displayed onto a table line.
		 * @param stopPoint
		 * @returns {boolean}
		 */
		$scope.isStopPointSelected = function (stopPoint) {
			if (ExploitationService.getCurrentStopPoint()) {
				return stopPoint.id === ExploitationService.getCurrentStopPoint().id;
			} else {
				return false;
			}
		};

		$scope.stopPointSelectedInTable = function (stopPoint,form) {
			$scope.data.editMode = false;
			ExploitationService.setCurrentStopPoint(stopPoint);
			OkinaLeafletService.setCenter({
				lat: stopPoint.latitude,
				lng: stopPoint.longitude,
				zoom: 20
			});
			$scope.setSelectedStop(stopPoint.id).then(() => {

				if ($scope.areModificationsAllowed) {
					$scope.enterEditMode(form);
					}

				}
			);
			// remonter quand le DOM est ok selon l'heuristique SCH de 50ms
			$timeout(function () {
				window.scrollTo({
					top: 0,
				});
			}, 50);
		};

		$scope.sortData = function (column) {
			$scope.reverseSort = ($scope.sortColumn === column) ? !$scope.reverseSort : false;
			$scope.sortColumn = column;
		};

		$scope.getSortClass = function (column) {
			if ($scope.sortColumn === column) {
				return $scope.reverseSort
					? 'fa fa-arrow-up'
					: 'fa fa-arrow-down';
			}
			return '';
		}

		function getDecimalNumber(decimal) {
			let decimalSize = 0;
			if (decimal) {
				let text = decimal.toString();
				let index = text.indexOf(".");
				if (index !== -1) {
					decimalSize = text.length - index - 1
				}
			}
			return decimalSize;
		}


		let linkImportStopsCSV;

		$scope.importStopsCSV = () => {
			linkImportStopsCSV = Utils.openModal($uibModal, "manual-import-stops-file.html", $scope, "lg");
		};

		$scope.getLinkToAbzu = () => {
			return ("/arrets/" + data.currentStopPoint.objectId);
		}

	}]);
